export default "__VITE_ASSET__AcPHfqUX__"